<template>
  <v-container class="fill-height login-page" fluid>
    <v-row align="center" justify="center">
      <v-col cols="10" align="center">
        <v-sheet class="login-box" color="#ffffff" max-width="400">
          <v-row align="center" justify="center">
            <v-col cols="6">
              <v-img src="images/logo.png" width="150" />
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="8" class="light-grey subtitle-2">
              <div v-if="!isStatusSuccess">Please enter your email</div>
            </v-col>
          </v-row>
          <v-alert color="green" dark v-if="isStatusSuccess"
            ><small
              >Successfully sent. Please check your email and follow the
              instructions</small
            ></v-alert
          >
          <v-row align="center" justify="center">
            <v-col cols="11">
              <v-form
                ref="form"
                v-model="valid"
                :lazy-validation="lazy"
                @submit.prevent="resetPassword"
                @keyup.enter.native="resetPassword"
              >
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  :disabled="isStatusLoading || isStatusSuccess"
                  label="Email"
                  required
                  @keyup.enter.native="resetPassword"
                  ref="email"
                ></v-text-field>
                <v-alert v-if="isSecureError" type="error">
                  {{ secureRestoreLinkError }}
                </v-alert>
                <v-row>
                  <v-col cols="6" class="pt-4">
                    <v-btn class="btn-text" text small color="primary" to="/"
                      >Back to login</v-btn
                    >
                  </v-col>
                  <v-col cols="6">
                    <v-btn
                      :disabled="isStatusLoading || isStatusSuccess || !valid"
                      color="success"
                      @click="resetPassword"
                      :loading="isStatusLoading"
                    >
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import actionTypes from "@/vuex/action-types";
import * as constants from "@/common/constants";

export default {
  name: "ForgotPassword",
  computed: {
    ...mapGetters(["secureRestoreLinkStatus", "secureRestoreLinkError"]),
    isSecureError() {
      return this.secureRestoreLinkStatus === constants.STATUS_ERROR;
    },
    isStatusLoading() {
      return this.secureRestoreLinkStatus === constants.STATUS_LOADING;
    },
    isStatusSuccess() {
      return this.secureRestoreLinkStatus === constants.STATUS_SUCCESS;
    }
  },
  data: () => ({
    valid: true,
    email: "",
    emailRules: [
      v => !!v || "Email is required",
      v => /.+@.+\..+/.test(v) || "Email must be valid"
    ],
    lazy: true
  }),
  methods: {
    ...mapActions([actionTypes.PASSWORD_RESTORE_LINK]),
    resetPassword: function() {
      if (this.valid) {
        const email = this.email;
        this[actionTypes.PASSWORD_RESTORE_LINK]({ email });
      }
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.email.focus());
  }
};
</script>
